import React, { useState, useEffect } from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "../../utilities/icons";
import FetchApi from "../../../AdminSide/Pages/Login/FetchApi";
import { BASEURL } from "../../../AdminSide/Components/Constants";
import Modal from "react-modal/lib/components/Modal";
import { ClientController } from "../../ClientController/ClientController";
import "./Project.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    height: 550,
    borderRadius: "15px",
    transition: "all 3s",
  },
};

const Projects = (props) => {
  const [modalData, setModalData] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [clickClount, setClickCount] = useState(0);

  let subtitle;

  const getProjects = async () => {
    return await FetchApi(BASEURL + "get_projects.php", "GET");
  };

  useEffect(() => {
    getProjects().then((res) => {
      setProjects(res && res.data);
    });
  }, []);

  const openModal = (project) => {
    setModalData(project);
    setIsOpen(true);
  };

  console.log(modalData);
  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const prevCarouselItem = () => {
    if (clickClount !== 0) {
      let firstCard = document.getElementsByClassName("project-card");
      if (clickClount <= firstCard.length - 3) {
        setClickCount(clickClount - 1);

        for (let i = 0; i < firstCard.length; i++) {
          // console.log(firstCard[i].)
          console.log(firstCard[i]);
          let a = firstCard[i].style.transform.substring(
            10,
            firstCard[i].style.transform.length - 3
          );
          firstCard[i].style.transform = `translate(${+a + 339}px)`;
        }
      }
    }
  };
  const nextCarouselItem = () => {
    let firstCard = document.getElementsByClassName("project-card");
    if (clickClount < firstCard.length - 3) {
      setClickCount(clickClount + 1);
      for (let i = 0; i < firstCard.length; i++) {
        // console.log(firstCard[i].)
        console.log(firstCard[i]);
        let a = firstCard[i].style.transform.substring(
          10,
          firstCard[i].style.transform.length - 3
        );
        firstCard[i].style.transform = `translate(${+a - 339}px)`;
      }
    }
  };
  const isActiveNextBtn = () => {
    let firstCard = document.getElementsByClassName("project-card");
    if (clickClount === 0 || clickClount < firstCard.length - 3) {
      return "projects-head__enabled-btn";
    } else {
      return "projects-head__disabled-btn";
    }
  };
  return (
    <ClientController pathname={props.location.pathname}>
      <div className="projects-section container-fluid">
        <div className="projects-head">
          <h1 className="projects-head__title">Biz qilgan loyihalar</h1>
          <div className="projects-head__btns">
            <button
              className={
                clickClount !== 0
                  ? "projects-head__enabled-btn"
                  : "projects-head__disabled-btn"
              }
              onClick={() => prevCarouselItem()}
            >
              <ArrowLeftIcon />
            </button>
            <button
              className={isActiveNextBtn()}
              onClick={() => nextCarouselItem()}
            >
              <ArrowRightIcon />
            </button>
          </div>
        </div>
        <div className="projects-container">
          <div className="projects-slider">
            {projects?.map((project) => (
              <div>
                <div className="project-card">
                  <div className="project-card-img">
                    <img src={BASEURL + project.image} alt="Bizning loyiha" />
                  </div>
                  <div className="project-card-info">
                    <div className="project-card-title">{project.title}</div>
                    <div className="project-card-text">
                      {project.description}
                    </div>
                    <button
                      className="project-card-button"
                      onClick={() => openModal(project)}
                    >
                      Batafsil
                    </button>
                  </div>
                </div>{" "}
              </div>
            ))}
            <Modal
              isOpen={modalIsOpen}
              onAfterOpen={afterOpenModal}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Example Modal"
            >
              <div className="about-head">
                <h4
                  className="modal-title"
                  ref={(_subtitle) => (subtitle = _subtitle)}
                >
                  {modalData.title}
                </h4>
                <i onClick={closeModal} class="fa-solid fa-rectangle-xmark"></i>
              </div>
              <img
                src={`https://imsoft.uz/api/${modalData.image}`}
                alt={modalData.title}
                className="modal-img"
              />
              <h4 className="modal-description">{modalData.description}</h4>
              <div className="modal-scroll">
                <p className="modal-about">{modalData.about}</p>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </ClientController>
  );
};

export default Projects;
